module.exports = __webpack_public_path__ + "static/distribution2-8c028197f2f14ca61876039e2476e291.jpg";